import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import Util from "classes/Util";
import TransfersPage, { getDefaultPageUI } from "components/pages/TransfersPage";
import Classes from "model";
import { useEffect } from "react";

/**
 * @name CaptureTransfersFromDD
 * @returns {React.Component}
 * @description The capture component for the transfers page with the from dropdown opened for the
 * transfers groups.
 * This capture is used in the following capture groups:
 * "Transfers" (abi22), "Transfers - Recurring" (abi22), "Transfers" (mabi23).
 */
export default function CaptureTransfersFromDD(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const { branding } = context.state;
    // Initalize a new instance of BCMSStateManagerCRUD using the default page ui
    // then update the isActive property of the from in the ui to true.
    // Call the submit to make the change.
    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI(undefined, context))
    .update([ "from", "isActive" ], true)
    .submit();

    useEffect(() => {
        Util.replaceDOMDataPointValues(branding);
    });

    // Return the TransfersPage passing the ui variable
    return <TransfersPage ui={ ui } />
}